import React, { useState, useMemo } from 'react';
import CommonBubble from '@home/components/CommonBubble';
import info from '@sg/assests/svg/info.svg';
import infoHover from '@sg/assests/svg/info-hover.svg';
import DOMPurify from 'dompurify';
import './index.scss';

interface IconType {
  tipString?: string;
  className?: string;
  mWidth?: any;
  overlayMaxHeight?: any;
  style?: React.CSSProperties;
}

export default function IconTipsCom(props: IconType) {
  const { tipString, className, style, mWidth, overlayMaxHeight } = props;

  const [isIconHover, setIsIconHover] = useState(false);

  const handleMouseEnter = () => {
    setIsIconHover(true);
  };

  const handleMouseLeave = () => {
    setIsIconHover(false);
  };

  const sanitizedContent = useMemo(() => {
    if (typeof tipString !== 'string') return tipString;
    const newText = tipString?.replace(/(\\n|\n)/g, '<br/>');
    const sanitizedContent = DOMPurify.sanitize(newText);
    return sanitizedContent;
  }, [tipString]);

  // Default 16px; callers can override via style (e.g. width/height: 14).
  const iconStyle = {
    width: '16px',
    height: '16px',
    ...style,
  };

  return (
    <div
      className={`dbs-icon-tips-icon ${className || ''}`}
    >
      <CommonBubble
        placement="top"
        dark
        style={{ maxWidth: mWidth || 'none', width: 'auto' }}
        content={mWidth && (typeof tipString === 'string' ?
          <div
            className='db-tipcontext-content'
            style={{ maxHeight: overlayMaxHeight ? overlayMaxHeight : 'unset' }}
            dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
          : <div style={{ whiteSpace: 'nowrap' }}>{tipString}</div>)}

      >
        <div
          className="dbs-icon-tips-wrapper"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={iconStyle}
        >
          <img
            src={isIconHover ? infoHover : info}
            alt="info"
            className="dbs-icon-tips-icon-svg"
            style={iconStyle}
          />
        </div>
      </CommonBubble>
    </div>
  );
}
